import Congratulations from './Congratulations';
export default Congratulations;
